import { useSelector, useDispatch } from "react-redux";
import { GnbWrap, HeaderWrap, Icons, Logo, TitleSelectDiv } from "header/headerStyle";
import Nav from "./Nav";
import { Link, useLocation } from "react-router-dom";

const LogoDiv = () => {
    return (
        <Logo>
            <span style={{ color: "#2000a0" }}>B</span>
            <span style={{ color: "#5530f4" }}>P</span>
            <span style={{ color: "#a498ff" }}>L</span>
        </Logo>
    );
};

const Header = () => {
    const userSelector = useSelector((store) => store.user);
    const { isAdmin, isReader, isWriter, isReviewer, isExternal, isSuperVisor } = userSelector;
    const path = window.location.pathname.substring(1, window.location.pathname.length);
    const common = useSelector((store) => store.common);
    const internal = common.external === "false";
    const location = useLocation();

    return (
        <HeaderWrap>
            <Nav />
            <GnbWrap>
                <div className="logo">
                    <h1>
                        <Link to={`/`}>
                            <LogoDiv />
                        </Link>
                    </h1>
                </div>
                <div className={`title`}>
                    <TitleSelectDiv></TitleSelectDiv>
                </div>
                <ul className="menu">
                    {(isAdmin || isSuperVisor) && internal && (
                        <li>
                            <Link to={"/"}>{`Home`}</Link>
                        </li>
                    )}
                    {isAdmin && (
                        <>
                            <li className={`has-child`}>
                                <p>System</p>
                                <div className={`sub-menu`}>
                                    <ul>
                                        <li>
                                            <Link
                                                to={"/admin/notice"}
                                                className={`${path === "admin/notice" ? "on" : ""}`}
                                            >{`Notice`}</Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={"/admin/audit-trail"}
                                                className={`${path === "admin/audit-trail" ? "on" : ""}`}
                                            >{`Audit Trail`}</Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={"/admin/batch"}
                                                className={`${path === "admin/batch" ? "on" : ""}`}
                                            >{`Batch`}</Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={"/admin/InterfaceStatus"}
                                                className={`${path === "admin/InterfaceStatus" ? "on" : ""}`}
                                            >{`Interface status`}</Link>
                                        </li>

                                    </ul>
                                </div>
                            </li>
                        </>
                    )}

                    {(isAdmin || isSuperVisor) && (
                        <>
                            <li className={`has-child`}>
                                <p>Master</p>
                                <div className={`sub-menu`}>
                                <ul>
                                        <li>
                                            <Link
                                                to={"/admin/masterTable"}
                                                className={`${path === "admin/masterTable" ? "on" : ""}`}
                                            >{`Master Data`}</Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={"/admin/descTemp"}
                                                className={`${path === "admin/descTemp" ? "on" : ""}`}
                                            >{`Template`}</Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li className={`has-child`}>
                                <p>User</p>
                                <div className={`sub-menu`}>
                                    <ul>
                                        {isAdmin && (
                                            <li>
                                                <Link
                                                    to={"/admin/userAuth"}
                                                    className={`${path === "admin/userAuth" || path === "admin" ? "on" : ""}`}
                                                >{`Access`}</Link>
                                            </li>
                                        )}
                                        {(isAdmin || isSuperVisor) && (
                                            <li>
                                                <Link
                                                    to={"/admin/ownerChg"}
                                                    className={`${
                                                        path === "admin/ownerChg" || (!isAdmin && path === "admin") ? "on" : ""
                                                    }`}
                                                >{`Owner`}</Link>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </li>
                        </>
                    )}
                </ul>
            </GnbWrap>

            {/* <div className={styles.container}>Container</div>
            <div className="container2">Container2</div> */}
        </HeaderWrap>
    );
};

export default Header;
